const API_URL_PATHS = {
	PROPERTIES_URL_PATH: '/properties',
	URLSETS_URL_PATH: '/url-sets',
	SCANS_URL_SUB_PATH: 'scans',
	TENANTS_URL_PATH: '/tenants',
	TENANT_OVERVIEW_URL_PATH: '/tenant-overview',
	SCAN_RESULTS_PATH: '/scan-results',
	USER_URL_PATH: '/user',
	DESCRIPTORS_URL_PATH: '/descriptors',
	VALIDATORS_URL_PATH: '/validators',
	USER_INVITATIONS_URL_PATH: '/user-invitations',
	TRENDS_PATH: '/trends',
	COMPARE_SCANS_PATH: '/scans/compare',
	PROPERTY_VIEWS_PATH: '/views',
	COLLECTIONS_URL_PATH: '/collections',
	CENTRAL_CONFIG_PATH: '/values/json'
};

export { API_URL_PATHS };
